import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { UserRepository } from "./user.repository";
import { User } from "./user.model";
import { catchError } from "rxjs/operators";

@Injectable()
export class UserResolver implements Resolve<User> {
  private userRepository = inject(UserRepository);

  resolve(
    route: ActivatedRouteSnapshot,
    rstate: RouterStateSnapshot,
  ): Observable<User> {
    if (route.params.id === "0") {
      return null;
    }

    return this.userRepository
      .get(route.params.id)
      .pipe(catchError((e) => of(null)));
  }
}
